import { useEffect } from 'react';
import client from 'src/gatsby-plugin-apollo/client';
import { GET_LAWFUL_PRESENCE_CONFIG, LawfulPresenceDisplayMode, useLazyQuery } from 'src/data';
import { asksLawfulPresence, LAWFUL_PRESENCE_STATE } from 'src/utils/lawfulPresence';

export const useLawfulPresence = (state?: string | null, zip?: string) => {
  const [fetchConfig, { data, loading }] = useLazyQuery(GET_LAWFUL_PRESENCE_CONFIG, {
    client,
    fetchPolicy: 'network-only',
  });

  const isAsked = state === LAWFUL_PRESENCE_STATE;

  useEffect(() => {
    if (!isAsked) return;
    fetchConfig();
  }, [isAsked, zip]);

  const mode = isAsked
    ? (data?.reference?.health?.askExplorerLawfulPresenceGA ?? LawfulPresenceDisplayMode.None)
    : LawfulPresenceDisplayMode.None;

  return {
    loading,
    mode,
    asks: asksLawfulPresence(mode),
  };
};
